duracion_min: 30
faseProduccion: 0
id: 2
preguntas: 3
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Cuentas y presupuesto
